import { useLanguage } from "@/context/LanguageContext";

const ProblemSection = () => {
  const { copy } = useLanguage();

  return (
    <section className="section" id="opportunite" data-testid="problem-section">
      <div className="container" data-testid="problem-container">
        <div className="section-header">
          <p className="section-kicker" data-testid="problem-kicker">
            {copy.problem.kicker}
          </p>
          <h2 className="section-title" data-testid="problem-title">
            {copy.problem.title}
          </h2>
        </div>
        <div className="problem-grid" data-testid="problem-grid">
          <p className="section-text" data-testid="problem-text">
            {copy.problem.body}
          </p>
          <div className="problem-card" data-testid="problem-card">
            <h3 data-testid="problem-card-title">{copy.problem.impactTitle}</h3>
            <ul data-testid="problem-card-list">
              {copy.problem.impactItems.map((item, index) => (
                <li key={item} data-testid={`problem-card-item-${index + 1}`}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="section-links" data-testid="problem-links">
          <a href="#solutions" className="text-link" data-testid="problem-link-solutions">
            {copy.problem.ctaPrimary}
          </a>
          <a href="#donate" className="text-link" data-testid="problem-link-donate">
            {copy.problem.ctaSecondary}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;